var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!../../../../../../.nodebrew/node/v6.10.0/lib/node_modules/babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./product-content.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-98cf96ae\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./product-content.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/product/product-content.vue
// module id = 46
// module chunks = 0